import { ChargeComponent } from "@/dto/subscription/SublimeChargeDTO";

export enum SubscriptionPlanStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export enum BillingMode {
  PREPAID = 'PREPAID',
  POSTPAID = 'POSTPAID',
}

export enum Periodicity {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  SEASONLY = 'SEASONLY',
  ANNUALLY = 'ANNUALLY',
}

export interface PlanComponentPriceDTO {
  id: number;
  unitPriceCents: number;
  effectiveFrom: string; // ISO LocalDate
  effectiveTo?: string | null; // ISO LocalDate or null
}

export interface PlanComponentDTO {
  id: number;
  component: ChargeComponent;
  billingMode: BillingMode;
  periodicity: Periodicity;
  prices: Array<PlanComponentPriceDTO>;
}

export interface PlanPriceOverrideDTO {
  planComponentId: number;
  unitPriceCents: number;
  effectiveFrom: string; // ISO LocalDate
  effectiveTo?: string | null; // ISO LocalDate or null
}

export interface OverridesByProfileDTO {
  profileId: number;
  profileCode: string;
  profileName: string;
  overrides: Array<PlanPriceOverrideDTO>;
}

export default interface SubscriptionPlanDTO {
  id: number;
  issuer: string; // SublimeCompany abbreviation per backend; display-friendly mapping in UI if needed
  code: string;
  version: number;
  status: SubscriptionPlanStatus;
  name: string;
  isPublic: boolean;
  components: Array<PlanComponentDTO>;
  createDate: string; // Date string
  overridesByProfile?: Array<OverridesByProfileDTO>;
}